import { useEffect, useState } from 'react';
import '../App.css';
import api from '../lib/api';

import { AdvancementpointDatatable } from "./datatables/advancementpointDatatable";
import { CertificateDatatable } from "./datatables/certificateDatatable";

function BunnyQualifications({ bunny, fetchBunnyInformation }) {
    const [advancementpoints, setAdvancementpoints] = useState([]);
    const [certificates, setCertificates] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchQualifications = async () => {
        try {
            const response = await api.get(`https://skhrf-api.cmdigital.se/v1/bunnies/qualifications?bunnyId=${bunny.id}`);
            const advancementpoints = response.data.advancementPoints.map(advancementpoint => ({
                ...advancementpoint,
            }));
            const certificates = response.data.certificates.map(certificate => ({
                ...certificate
            }))
                ;
            setAdvancementpoints(advancementpoints);
            setCertificates(certificates);
        } catch (error) {
            console.error('Error fetching qualifications:', error);
            setAdvancementpoints([])
            setCertificates([])
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchQualifications();
    }, [bunny]);

    return (
        <div className='flex flex-col gap-3'>
            <AdvancementpointDatatable bunny={bunny} advancementpoints={advancementpoints} isLoading={isLoading} fetchQualifications={fetchQualifications} reloadBunnySinglePage={fetchBunnyInformation} />
            <CertificateDatatable bunny={bunny} certificates={certificates} isLoading={isLoading} fetchQualifications={fetchQualifications} reloadBunnySinglePage={fetchBunnyInformation} />
        </div>
    )
}

export default BunnyQualifications;